var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPaginationArrowRightDouble(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 11,
    viewBox: "0 0 12 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.75949 0.000205415L12 5.20275L6.75949 10.4053L6 9.64578L10.481 5.20275L6 0.7597L6.75949 0.000205415Z",
    fill: "#666E7D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.759494 0.000205415L6 5.20275L0.759494 10.4053L9.96715e-08 9.64578L4.48101 5.20275L9.96715e-08 0.7597L0.759494 0.000205415Z",
    fill: "#666E7D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaginationArrowRightDouble);
export default __webpack_public_path__ + "static/media/pagination-arrow-right-double.3393b6e75f8826e4eb3cb6eda4d1ff8f.svg";
export { ForwardRef as ReactComponent };